// extracted by mini-css-extract-plugin
module.exports = {"background":"ContextMenu_background__3yusc","menu":"ContextMenu_menu__smjZF","item":"ContextMenu_item__1cD1k","title":"ContextMenu_title__3T0zH","line":"ContextMenu_line__2L_WC"};